// Firebase configuration for Development (jaimee-dev)
const firebaseConfig = {
  apiKey: "AIzaSyDnlFRXhmAy8SrqnpC5Z_NEaqTu9izOO8Q",
  authDomain: "jaimee-dev.firebaseapp.com",
  projectId: "jaimee-dev",
  storageBucket: "jaimee-dev.firebasestorage.app",
  messagingSenderId: "776959529557",
  appId: "1:776959529557:web:e2356c8feecf3a8f5b3adc",
  measurementId: "G-8Q0547VS17"
};

export default firebaseConfig;
